import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import axios from 'axios';
import memoize from 'lodash/memoize';
import RealTimeEvents from '../misc/RealTimeEvents';
import FeathersEvents from './FeathersEvents';

/**
 * Memoized event manager factory.
 */
export var getEventsManager = memoize(function getEventsManager(host, token) {
  return new RealTimeEvents().connect(host, token);
});

/**
 * Memoized feathers event manager factory.
 */
export var getFeathersEventManager = memoize(function getFeathersEventManager(host, token, params) {
  return new FeathersEvents().connect(host, token, params);
});

/**
 * API client base.
 */
export var APIClient = /*#__PURE__*/function () {
  /**
   * Constructor.
   *
   * @param {Function} config.getToken
   * @param {string} config.baseURL
   * @param {Record<string,unknown>} config.globalParams
   */
  function APIClient(config) {
    _classCallCheck(this, APIClient);
    if (!config) {
      throw new Error('No config given.');
    }
    if (!config.baseURL) {
      throw new Error('No config.baseURL given.');
    }
    this.config = _objectSpread({}, config);
  }

  /**
   * Client getter.
   */
  return _createClass(APIClient, [{
    key: "client",
    get: function get() {
      var token = this.config.getToken();
      return axios.create({
        baseURL: this.config.baseURL.startsWith('/') ? "".concat(window.location.origin).concat(this.config.baseURL) : this.config.baseURL,
        params: _objectSpread({}, this.config.globalParams),
        headers: _objectSpread({}, token && {
          Authorization: "Bearer ".concat(token)
        })
      });
    }

    /**
     * Don't call this until we have a token.
     */
  }, {
    key: "subscribe",
    value: function subscribe(event, callback) {
      var token = this.config.getToken();
      var manager = getEventsManager(this.config.baseURL.startsWith('/') ? "".concat(window.location.origin).concat(this.config.baseURL) : this.config.baseURL, token);
      return manager.subscribe(event, callback);
    }

    /**
     * The garbage version of subscribe.
     *
     * @param {*} service
     * @param {*} event
     * @param {*} callback
     */
  }, {
    key: "feathersSubscribe",
    value: function feathersSubscribe(service, event, callback) {
      var token = this.config.getToken();
      var manager = getFeathersEventManager(this.config.baseURL.startsWith('/') ? "".concat(window.location.origin).concat(this.config.baseURL) : this.config.baseURL, token, this.config.globalParams);
      return manager.subscribe(service, event, callback);
    }

    /**
     * Helper to extract data.
     */
  }, {
    key: "_data",
    value: function _data(resp) {
      return resp.data;
    }
  }]);
}();

/**
 * Standard Crud API client. Does cruddy things.
 */
export var CrudAPIClient = /*#__PURE__*/function (_APIClient) {
  function CrudAPIClient() {
    _classCallCheck(this, CrudAPIClient);
    return _callSuper(this, CrudAPIClient, arguments);
  }
  _inherits(CrudAPIClient, _APIClient);
  return _createClass(CrudAPIClient, [{
    key: "getResourceUrl",
    value:
    /**
     * Called by each method to get the resource URI.
     *
     * @param {*} id
     */
    function getResourceUrl(id) {
      if (!this.prefix) {
        throw new Error("No prefix for default implementation of getResourceUrl");
      }
      return this.prefix + (id ? "/".concat(id) : '');
    }

    /**
     * Finds something.
     *
     * @param {*} params
     */
  }, {
    key: "find",
    value: function find(params) {
      return this.client.get(this.getResourceUrl(null, null, params, 'find'), {
        params: params
      }).then(this._data);
    }

    /**
     * Gets something by ID.
     *
     * @param {*} params
     */
  }, {
    key: "get",
    value: function get(id, params) {
      return this.client.get(this.getResourceUrl(id, null, params, 'get'), {
        params: params
      }).then(this._data);
    }

    /**
     * Gets something by ID.
     *
     * @param {*} params
     */
  }, {
    key: "getMany",
    value: function getMany(payload, params) {
      return this.client.post(this.getResourceUrl('id-query', payload, params, 'getMany'), payload, {
        params: params
      }).then(this._data);
    }

    /**
     * Creates something.
     *
     * @param {*} data
     */
  }, {
    key: "create",
    value: function create(data, params) {
      return this.client.post(this.getResourceUrl(null, data, params, 'create'), data, {
        params: params
      }).then(this._data);
    }

    /**
     * Updates something.
     *
     * @param {*} data
     */
  }, {
    key: "update",
    value: function update(id, data, params) {
      return this.client.patch(this.getResourceUrl(id, data, params, 'update'), data, {
        params: params
      }).then(this._data);
    }

    /**
     * Updates something.
     *
     */
  }, {
    key: "updateLastLogin",
    value: function updateLastLogin(workspace_id) {
      return this.client.patch("/v3/workspaces/".concat(workspace_id, "/login")).then(this._data);
    }

    /**
     * Updates something.
     *
     */
  }, {
    key: "updateLastSeen",
    value: function updateLastSeen(workspace_id) {
      return this.client.patch("/v3/workspaces/".concat(workspace_id, "/ping")).then(this._data);
    }

    /**
     * Updates something.
     *
     * @param {*} data
     */
  }, {
    key: "delete",
    value: function _delete(id, params) {
      return this.client.delete(this.getResourceUrl(id, null, params, 'delete'), {
        params: params
      }).then(this._data);
    }
  }]);
}(APIClient);

/**
 * Creates a function that implements `getResourceUrl` in a way that prefixes
 * with `/workspaces/:workspace_id` when appropriate.
 *
 * @param {*} prefix
 * @param {*} resource
 */
export function createWorkspacedResourceUrlGetter(resource) {
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return function (id, data, params) {
    var workspaceId = params && params.workspace_id;
    var url = prefix;
    if (workspaceId) {
      url += "/workspaces/".concat(workspaceId);
    }
    url += '/' + resource;
    if (id) {
      url += '/' + encodeURIComponent(id);
    }
    return url;
  };
}
//# sourceMappingURL=APIClient.js.map
